/** Shared display labels for incident / damaged-item kinds in Admin UI. */
export const INCIDENT_KIND_DISPLAY_LABELS: Record<string, string> = {
  damaged: 'Damaged',
  ped: 'Damaged Before Pickup',
  wh_created: 'Warehouse Created',
  not_routed: 'Not Routed',
  no_scan_return: 'No Scan Return',
};

export const DAMAGED_ITEM_KIND_DISPLAY_LABELS: Record<string, string> = {
  clutter_caused: 'Damaged',
  preexisting: 'Damaged Before Pickup',
  CLUTTER_CAUSED: 'Damaged',
  PREEXISTING: 'Damaged Before Pickup',
};

export function incidentKindDisplayLabel(kind: string | null | undefined): string | undefined {
  if (!kind) return undefined;
  const key = kind.toLowerCase();
  return INCIDENT_KIND_DISPLAY_LABELS[key];
}

export function damagedItemKindDisplayLabel(kind: string): string {
  return DAMAGED_ITEM_KIND_DISPLAY_LABELS[kind] ?? DAMAGED_ITEM_KIND_DISPLAY_LABELS[kind.toLowerCase()] ?? kind;
}
